import TrackingService from 'app/services/tracking/tracking.service';
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";

const NS = 'NewSectionCtrl';

export default function NewSectionCtrl(
  $log, $mdDialog
) {
  "ngInject";

  TrackingService.trackPageView('settings.sections.new');

  const vm = this;

  // states
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.SUCCESS = 2;
  vm.ERROR = 3;
  vm.state = vm.ENTER;
  //-- define public methods
  vm.cancel = cancel;
  vm.save = save;

  function cancel() {
    $mdDialog.hide();
  }

  function save(isValid) {
    if (isValid) {
      vm.state = vm.LOADING;
      // add
      SectionLookupService.addSection(vm.name).then(function () {
        vm.state = vm.SUCCESS;
        $mdDialog.hide();
      }).catch(function () {
        vm.state = vm.ENTER;
      });
    } else {
      vm.displayErrors = true;
    }
  }
}
